import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IPostBookMarkLessonById } from '@/Module/Lesson/Model/ApiModel';
import type { IBookmark } from '@/Module/Lesson/Model/DataModel';
import lessonService from '@/Module/Lesson/Service/LessonService';

export const deleteBookmarkLessonByIdAction = createAsyncThunk<IPostBookMarkLessonById, IBookmark['id']>(
  'lesson/deleteBookmark ',
  (id, { signal }) => {
    return lessonService
      .deleteBookMarkById(
        {
          id,
        },
        signal,
      )
      .then(({ data: { data } }) => data);
  },
);
